// extracted by mini-css-extract-plugin
module.exports =  {"headerColumn":"style-module_headerColumn__RFVl10fRTmh0PdZ9uOPh","rowColumn":"style-module_rowColumn__Rtxf51dzZb1va_35zaDx","center":"style-module_center__v9fi4hnD7oiX2_Edvpdv"};